import React from 'react';
import './TooltipContentContainer.scss';

export const tooltipContentContainerId = 'tooltip-content-container';

export default function TooltipContentContainer() {
	return (
		<div id={tooltipContentContainerId}></div>
	);
}
